module.exports = __webpack_public_path__ + "img/Mask Group 140 (1).856a7577.svg";